// extracted by mini-css-extract-plugin
export var avatarContainer = "_av-0";
export var avatarTypingWave = "_av-i";
export var gray = "_av-f";
export var green = "_av-c";
export var icon = "_av-9";
export var image = "_av-1";
export var lg = "_av-6";
export var md = "_av-5";
export var presenceDot = "_av-b";
export var red = "_av-d";
export var sm = "_av-4";
export var status = "_av-a";
export var typingDot = "_av-h";
export var typingPill = "_av-g";
export var xl = "_av-7";
export var xs = "_av-3";
export var xxl = "_av-8";
export var xxs = "_av-2";
export var yellow = "_av-e";